import { useEffect } from 'react';

import { pauseAudioEye } from './pauseAudioEye';

export function usePauseAudioEye() {
    useEffect(() => () => pauseAudioEye(), []);
}

export default usePauseAudioEye;
